import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=664f34cc&scoped=true&lang=html&"
import script from "./Spacer.vue?vue&type=script&lang=js&"
export * from "./Spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f34cc",
  null
  
)

export default component.exports